import { useEffect } from "react";

const SITE = "Deaf Education Consulting LLC";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : `${SITE} | Deaf & Hard of Hearing Education Support`;
    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
  }, [title, description]);
}
